import { Component } from 'react';
import withAuth from '../../components/withAuth';
import { withStyles } from '@mui/styles';
import { compose } from "redux";
import { connect } from "react-redux";
import AbsenceFieldsForm from './AbsenceFieldsForm';
import AbsenceTableForm from './AbsenceTableForm';
import { redirect } from "../../redux/absences/absencesActions";
import PropTypes from 'prop-types';
import AbsenceCounters from './AbsenceCounters';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import AbsenceActionsForm from "./AbsenceActionsForm";
import './AbsenceForm.css';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AbsenceStatusTimeLine from '../../components/Absences/AbsenceStatusTimeLine'

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing(3),
        overflowX: 'auto',
    },
    table: {
        minWidth: 700,
    },
    row: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.background.default,
        },
    },
});

class AbsenceForm extends Component {
    static propTypes = {
        readonly: PropTypes.bool.isRequired,
    }

    constructor(props) {
        super(props);
        this.props.resetRedirect();

        this.state = {}//Obligé si on a un getDerivedStateFromProps
    }

    static getDerivedStateFromProps(nextProps) {
        if (nextProps.redirectUrl !== null) {
            nextProps.history.push(nextProps.redirectUrl);
            nextProps.resetRedirect();
        }

        return null
    }

    render() {
        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
                <div className="col-lg-12 col-md-12 col-sm-12 col-12 absence">
                    <div className="row absence-margin">
                        <Card className="card col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
                            <CardContent>
                                <div className="offset-lg-9 col-lg-3 offset-md-8 col-md-4 offset-sm-7 col-sm-5 offset-3 col-9 control-margin-top">
                                    <AbsenceStatusTimeLine currentStatus={this.props.absences.absenceCreationFields.status} />
                                </div>
                                <div className="row control-margin-top">
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-12 without-side-padding">
                                        <Accordion>
                                            <AccordionSummary className="without-side-padding" expandIcon={<ExpandMoreIcon />}>
                                                <Typography className="expandable-label-counter">Voir les compteurs</Typography>
                                            </AccordionSummary>
                                            <AccordionDetails className="without-padding">
                                                <AbsenceCounters />
                                            </AccordionDetails>
                                        </Accordion>
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-12 col-12 without-side-padding">
                                        <AbsenceFieldsForm readonly={this.props.readonly} />
                                    </div>
                                </div>
                            </CardContent>
                        </Card>

                        <AbsenceTableForm readonly={this.props.readonly} />
                        <AbsenceActionsForm />
                    </div>
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        absences: state.absences,
        redirectUrl: state.absences.redirectUrl
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        resetRedirect: () => dispatch(redirect(null)),
    };
};

export default compose(withAuth, withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(AbsenceForm);
